import cover from "../banner/banner.png";
import Paper from "@mui/material/Paper";
import { styled, alpha } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import BannerCard from "./card";

// const Item_Paper = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.color.main,
//   textAlign: "center",
//   color: theme.palette.text.banner,
//   marginRight: "1px",
//   marginLeft: "1px",
// }));

const Item = styled(Paper)(({ theme }) => ({
  // backgroundImage: `url(${cover})`,
  // backgroundRepeat: "no-repeat",
  // backgroundSize: "cover",
  // backgroundColor: alpha(theme.color.main, 1),
  background: `linear-gradient(to top , ${theme.color.gradient1}, ${theme.color.gradient2},${theme.color.gradient3})`,

  minHeight: "40vh",
  // ...theme.typography.body2,
  // padding: theme.spacing(1),
  // textAlign: "center",
  // color: theme.palette.text.secondary,
  // marginTop: "0px",
}));
// const Item_Paper = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.color.secondary,
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

const Item_Img = styled("div")(({ theme }) => ({
  backgroundImage: `url(${cover})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  height: "150px",
  width: "330px",
  // marginLeft: 0,
  // margin: "0 auto",

  // height: "100%",
  // objectFit: "contain",
  // width: "50%",
  // height: "25vh",
  // width: "100%",
  // minHeight: "700px",
  // minWidth: "350px",
  // [theme.breakpoints.up("xs")]: {
  //   height: "15vh",
  //   width: "100%",
  // },
  // [theme.breakpoints.up("xs")]: {
  //   height: "18vh",
  //   width: "100%",
  // },

  // [theme.breakpoints.up("sm")]: {
  //   height: "14vh",
  //   width: "100%",
  // },

  [theme.breakpoints.up("md")]: {
    height: "200px",
    width: "420px",
  },
  [theme.breakpoints.up("lg")]: {
    height: "300px",
    width: "660px",
  },
  // [theme.breakpoints.up("xl")]: {
  //   height: "300px",
  //   width: "660px",
  // },
}));

const Text = styled("Typography")(({ theme }) => ({
  color: theme.palette.text.banner,
}));

export default function BannerApp() {
  return (
    <Item
    // sx={{
    //   mt: "100px",
    //   backgroundImage: `url(${cover})`,
    //   backgroundRepeat: "no-repeat",
    //   backgroundSize: "cover",
    //   height: "30%",
    //   minHeight: "285px",
    //   minWidth: "350px",
    //   borderRadius: 2,
    //   marginTop: "50px",
    // }}
    >
      <Grid container spacing={0}>
        <Grid
          container
          spacing={1}
          size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}
          direction="column"
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text sx={{ fontSize: "1.3rem", textAlign: "center" }}>
            Рязанская федерация пауэрлифтинга(РФСОО «РФП»)
          </Text>
          <Item_Img></Item_Img>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}
          spacing={1}
          container
          direction="column"
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid>
            <BannerCard />
          </Grid>
          <Grid></Grid>
        </Grid>

        {/* <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}></Grid> */}
      </Grid>
    </Item>
  );
}
